'use client'

import { useInitGlobalAddToCart } from '@/features/cart/init-global-events'

import { useInitYandexSettings } from '@/shared/integrations/yandex-metric'

/**
 * Client-only side effects for the home page (global add-to-cart handler,
 * Yandex Rotor settings). Isolated here so the rest of the page can stay
 * a Server Component and ship no JS for its static sections.
 */
export const HomeInit = (): any => {
	useInitGlobalAddToCart()
	useInitYandexSettings()

	return null
}
